<template lang="pug">
  .container.grid-lg.py-2
    .panel
      .panel-header
        .h4.text-primary Novo Documento
        div Tipo: #[b {{ `enums.db.enum_doc_tipo.${$route.params.docTipo}` | translate }}]
        div(v-if="$route.name !== 'fiscalizacao.docs.create.modelo'")
          .divider
          steps.pt-2(:steps="steps")
        .divider
      .panel-body.mb-2
        p.text-large - Escolha o modelo do Documento
        .empty(v-if="loading")
          .loading-container
            .loading.loading-lg
          p.empty-title.h5 Carregando dados
          p.empty-subtitle Aguarde um momento, estamos buscando as informações para você
        div(v-else)
          form.list-filters(@submit.prevent='listar')
            .columns.align-end
              .column.col-auto
                .form-group
                  small #[abbr #]{{ 'doc_modelo.id' | tModel }}
                  int.form-input.input-sm(v-model="q.id_eq" placeholder='#')
              .column.col-4
                .form-group
                  small {{ 'doc_modelo.descricao' | tModel }}/{{ 'doc_modelo.titulo' | tModel }}
                  input.form-input.input-sm(v-model="q.descricao_or_titulo_cont" v-autofocus)
              .column.col-auto
                button.btn.btn-action.s-circle.btn-sm
                  i.fa.fa-filter
          .divider
          .columns
            .column.col-6.col-md-12
              div(v-for="modelo in list")
                a.doc-tipo-item.columns.align-center.no-decoration.c-hand.mb-2.py-1.s-rounded(
                  @click="onSelectModelo(modelo)"
                )
                  .column.col-auto #[small #]{{ modelo.id }}
                  .column {{ modelo.titulo }}
                    div.text-small.text-dark {{ modelo.descricao }}
                  .column.col-auto
                    i.fa.fa-angle-right.fa-lg
              .divider
              btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import api from '@/api/fiscalizacao/docs'
import Doc from '@/models/Doc'
import { LocalStorageFacade } from 'paliari-js-utils'

export default {
  vuex: {
    'sistema/docModelos': {
      state: ['list', 'page', 'pages', 'count'],
      actions: ['fetchList', 'prevPage', 'nextPage', 'goPage'],
      mutations: ['setQuery', 'setPage'],
    },
  },
  props: { docTipo: { type: String } },
  data() {
    return { loading: false, q: { id_eq: '', descricao_or_titulo_cont: '' } }
  },
  methods: {
    async onSelectModelo(modelo) {
      try {
        this.loading = true
        const response = await api.new(modelo.id)
        const doc = new Doc(response)
        const steps = doc.modelo.params.osm.steps.web
        LocalStorageFacade.setItem('doc', doc)
        LocalStorageFacade.setItem('steps', steps)
        this.$router.push({
          name: 'fiscalizacao.docs.create.info',
          params: this.$route.params,
        })
      } catch (e) {
        this.$toaster.error('Falha ao inicializar o Documeto')
      } finally {
        this.loading = false
      }
    },
    async listar() {
      try {
        this.loading = true
        this.setQuery({ tipo_eq: this.docTipo, ativo_eq: true, ...this.q })
        this.setPage(1)
        await this.fetchList()
      } catch (e) {
        this.$toaster.error('Falha ao buscar os modelos')
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.listar()
  },
}
</script>

<style lang="stylus" scoped>
.no-decoration
  text-decoration none
.doc-tipo-item:hover
  background-color #fafafa
</style>
